import React from "react";

export default class SimpleText extends React.PureComponent {
    render() {
        return this.props.value || "";
    }
}
